import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class Summary extends Component {
    constructor() {
        super();
        this.state = {
            statisticsData: {
                noOfUniqueUserChat: 0,
                uniqueUserChatScaleType: "",
                noOfAnonymousUserChat: 0,
                anonymousUserChatScaleType: "",
                noOfTotalUserChat: 0,
                totalUserChatScaleType: "",
                noOfYesterdayChat: 0,
                yesterdayChatScaleType: "",
                noOfLast7DayChat: 0,
                last7DayChatScaleType: "",
                noOfLast30DayChat: 0,
                last30DayChatScaleType: "",
                noOfUserQueryYesterday: 0,
                yesterdayUserQueryScaleType: "",
                noOfUserQuery7Day: 0,
                last7DayUserQueryScaleType: "",
                noOfUserQuery30Day: "0",
                last30DayUserQueryScaleType: "",
                userQueryAvgYesterday: "0%",
                userQueryAvg7Day: "0%",
                userQueryAvg30Day: "0%"
            }
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchTotalDataApi();
        }, 300);
        var thisComponent = this;
        document.addEventListener("projectChanged", function (event) {
            thisComponent.projectId = event.projectId;
            thisComponent.fetchTotalDataApi(event.projectId);
        });
    }

    fetchTotalDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var StatisticsController = this;
        $.ajax({
            url: "/api/no-of-chat-data",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        StatisticsController.state.statisticsData = res.result;
                        StatisticsController.setState(StatisticsController.state);
                    }
                }
            }
        });
    }

    render() {
        return (
            <div className="col-lg-12" style={{ marginLeft: "20px" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <ToastContainer className="Toast-at-center" />
                <h6 className="nav-item" style={{
                    color: '#282a65',
                    marginTop: '10px'
                }}>Conversation Summary :</h6>
                <div className="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfYesterdayChat}{this.state.statisticsData.yesterdayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Yesterday</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfLast7DayChat}{this.state.statisticsData.last7DayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Conversations<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfLast30DayChat}{this.state.statisticsData.last30DayChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                        </div>
                    </div>
                </div>

                <h6 className="nav-item" style={{
                    color: '#282a65',
                    marginTop: '10px'
                }}>Queries Summary :</h6>
                <div className="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfUserQueryYesterday}{this.state.statisticsData.yesterdayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Yesterday</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfUserQuery7Day}{this.state.statisticsData.last7DayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Queries Served<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfUserQuery30Day}{this.state.statisticsData.last30DayUserQueryScaleType}<br />
                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                        </div>
                    </div>
                </div>

                <h6 className="nav-item" style={{
                    color: '#282a65',
                    marginTop: '10px'
                }}>Avg Queries Summary :</h6>
                <div className="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Average<br />Queries Served<br />per Conversation<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.userQueryAvgYesterday}<br />
                            <div style={{ fontSize: "10px" }}>Yesterday</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Average<br />Queries Served<br />per Conversation<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.userQueryAvg7Day}<br />
                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "rgb(184, 207, 222)",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Average<br />Queries Served<br />per Conversation<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.userQueryAvg30Day}<br />
                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                        </div>
                    </div>
                </div>

                <h6 className="nav-item" style={{
                    color: '#282a65',
                    marginTop: '10px'
                }}>Users Summary :</h6>
                <div className="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfTotalUserChat}{this.state.statisticsData.totalUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#93D2FA",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of Unique<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfUniqueUserChat}{this.state.statisticsData.uniqueUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of Anonymous<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.statisticsData.noOfAnonymousUserChat}{this.state.statisticsData.anonymousUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Summary;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/Summary.js